<template>
  <div>
    <div class="main_banner">
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="7" md="7" sm="12">
            <div class="left_section">
              <h1>
                Salutes you Company -
                <br />Online Loan Website !
              </h1>
              <p>
                It is the first service that works with customers in online mode, without
                the help of a human operator! Its operation is fully automated. Any day
                of the week, regardless of time, holidays or non-working days, loans
                instantly.
              </p>
            </div>
          </b-col>
          <b-col cols="12" lg="5" md="5" sm="12">
            <div class="right_section"></div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="news_cont">
      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="4" md="12" sm="12">
            <div class="right_side">
              <nav-list />
              <estimator />
            </div>
          </b-col>
          <b-col cols="12" lg="8" md="12" sm="12">
            <div class="left_side">
            <h3 class="mb-5">Privacy Policy</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                <b-img class="mx-auto d-block mt-5" :src="require('@/assets/images/logo.png')"></b-img>
            
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import estimator from "@/components/estimator.vue";
import navList from "@/views/contacts/navlist.vue"

export default {
  components: {
    estimator,
    navList
  },
  data() {
    return {};
  }
};
</script>
<style>
.loan_form .estimator_signin {
  margin-top: 75px;
}
</style>

<style lang="scss" scoped>
.main_banner {
  width: 100%;
  background: url("../../assets/images/contact/banner_contact.jpg");
  background-position: center;
  background-size: cover;
  position: relative;
  padding: 60px 0;
  h1 {
    color: #fff;
    font-weight: 600;
  }
  p {
    color: #fff;
    margin-top: 20px;
  }
  .left_section {
    padding-left: 50px;
  }
}
.news_cont {
  padding: 80px 0 120px;
  .left_side {
    padding-left: 30px;
    .contact_items {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 30px;
      .info {
        padding-left: 40px;
        p {
          margin-bottom: 0;
        }
        small {
          opacity: 0.7;
        }
      }
    }
  }
}
@media (max-width: 992px) {
  .news_cont {
    .left_side {
      padding-left: 0;
      margin-top: 30px;
    }
  }
}

@media (max-width: 768px) {
  .main_banner {
    background: url("../../assets/images/banner-blue.jpg");
    .left_section {
      padding-left: 0;
    }
  }
}
@media (max-width: 720px) {
  .news_cont .left_side .card {
    flex-direction: column !important;
  }
}
</style>